export { EquipmentDetails } from './EquipmentInfo';
